// src/pages/StoresPage.js
import React, { useState, useEffect } from 'react';
import { getStores, createStore, updateStore, deleteStore } from '../api/apiService';

const bs = { fontFamily: "'Montserrat', sans-serif" };
const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const inputStyle = {
  ...bs, width: '100%', padding: '10px 14px',
  border: '1px solid #e5e0e0', fontSize: '13px', color: '#060D14',
  outline: 'none', borderRadius: '2px', boxSizing: 'border-box',
  transition: 'border-color 0.2s', background: 'white',
};

const StoresPage = () => {
  const [stores,       setStores]       = useState([]);
  const [newName,      setNewName]      = useState('');
  const [newAddress,   setNewAddress]   = useState('');
  const [editingStore, setEditingStore] = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [saving,       setSaving]       = useState(false);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      setStores(await getStores());
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    setSaving(true);
    try {
      await createStore({ name: newName.trim(), address: newAddress.trim() });
      setNewName(''); setNewAddress('');
      await load();
    } catch (e) { alert('Error al crear tienda.'); }
    finally { setSaving(false); }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editingStore?.name.trim()) return;
    setSaving(true);
    try {
      await updateStore({
        id:      editingStore.id,
        name:    editingStore.name.trim(),
        address: editingStore.address || '',
        is_public: editingStore.is_public ? 1 : 0,
      });
      setEditingStore(null);
      await load();
    } catch (e) { alert('Error al actualizar tienda.'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta tienda? Esta acción no se puede deshacer.')) return;
    try {
      await deleteStore(id);
      await load();
    } catch (e) { alert('Error al eliminar tienda.'); }
  };

  // FIX: marcar tienda pública directamente en la BD via updateStore
  const handleSetPublic = async (store) => {
    try {
      // Primero quitar is_public de todas (el PHP ya lo hace, pero lo reflejamos en UI)
      await updateStore({ id: store.id, name: store.name,
        address: store.address || '', is_public: 1 });
      await load();
    } catch (e) { alert('Error al configurar tienda pública.'); }
  };

  const publicStore = stores.find(s => s.is_public);

  return (
    <div style={{ padding: '24px 16px', maxWidth: '900px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ ...ds, fontSize: '2rem', fontWeight: 400, color: '#060D14', margin: '0 0 4px' }}>
          Tiendas
        </h1>
        <p style={{ ...bs, fontSize: '12px', color: '#bbb', margin: 0 }}>
          {stores.length} tienda{stores.length !== 1 ? 's' : ''} registrada{stores.length !== 1 ? 's' : ''}
          {publicStore && ` · Pública: ${publicStore.name}`}
        </p>
      </div>

      {/* Formulario agregar / editar */}
      <div style={{ background: 'white', border: '1px solid #f0eaea',
        padding: '24px', borderRadius: '2px', marginBottom: '16px' }}>
        <h2 style={{ ...ds, fontSize: '1.3rem', fontWeight: 600,
          color: '#060D14', marginBottom: '16px' }}>
          {editingStore ? 'Editar Tienda' : 'Nueva Tienda'}
        </h2>

        <form onSubmit={editingStore ? handleUpdate : handleAdd}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px',
            marginBottom: '14px' }}>
            <div>
              <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.18em',
                textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>
                Nombre *
              </label>
              <input type="text" required
                value={editingStore ? editingStore.name : newName}
                onChange={e => editingStore
                  ? setEditingStore({ ...editingStore, name: e.target.value })
                  : setNewName(e.target.value)}
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = '#961914'}
                onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
            </div>
            <div>
              <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.18em',
                textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>
                Dirección
              </label>
              <input type="text"
                value={editingStore ? (editingStore.address || '') : newAddress}
                onChange={e => editingStore
                  ? setEditingStore({ ...editingStore, address: e.target.value })
                  : setNewAddress(e.target.value)}
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = '#961914'}
                onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" disabled={saving} style={{
              ...bs, background: '#961914', color: 'white', border: 'none',
              padding: '10px 24px', cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: '10px', fontWeight: 600, letterSpacing: '0.15em',
              textTransform: 'uppercase', borderRadius: '2px', opacity: saving ? 0.7 : 1,
              transition: 'background 0.2s',
            }}
            onMouseOver={e => { if (!saving) e.currentTarget.style.background = '#7a140f'; }}
            onMouseOut={e => e.currentTarget.style.background = '#961914'}>
              {saving ? 'Guardando…' : editingStore ? 'Actualizar' : 'Agregar'}
            </button>
            {editingStore && (
              <button type="button" onClick={() => setEditingStore(null)} style={{
                ...bs, background: 'none', border: '1px solid #e5e0e0', color: '#666',
                padding: '10px 20px', cursor: 'pointer', fontSize: '10px',
                fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase',
                borderRadius: '2px', transition: 'all 0.2s',
              }}
              onMouseOver={e => { e.currentTarget.style.borderColor = '#961914'; e.currentTarget.style.color = '#961914'; }}
              onMouseOut={e => { e.currentTarget.style.borderColor = '#e5e0e0'; e.currentTarget.style.color = '#666'; }}>
                Cancelar
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Lista de tiendas */}
      <div style={{ background: 'white', border: '1px solid #f0eaea',
        borderRadius: '2px', overflow: 'hidden' }}>

        <div style={{ padding: '10px 20px', background: '#faf9f9',
          borderBottom: '1px solid #f0eaea', display: 'grid',
          gridTemplateColumns: '1fr 200px 120px 120px' }}>
          {['Tienda', 'Dirección', 'Estado', 'Acciones'].map(h => (
            <span key={h} style={{ ...bs, fontSize: '10px', fontWeight: 600,
              letterSpacing: '0.15em', textTransform: 'uppercase', color: '#bbb' }}>
              {h}
            </span>
          ))}
        </div>

        {loading ? (
          <div style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>Cargando tiendas…</p>
          </div>
        ) : stores.length === 0 ? (
          <div style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>No hay tiendas registradas.</p>
          </div>
        ) : (
          stores.map((store, idx) => (
            <div key={store.id} style={{
              display: 'grid', gridTemplateColumns: '1fr 200px 120px 120px',
              padding: '14px 20px', alignItems: 'center',
              borderBottom: idx < stores.length - 1 ? '1px solid #faf5f5' : 'none',
              background: idx % 2 === 0 ? 'white' : '#fdfafa',
              transition: 'background 0.15s',
            }}
            onMouseOver={e => e.currentTarget.style.background = '#fdf5f5'}
            onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? 'white' : '#fdfafa'}>

              <div>
                <p style={{ ...ds, fontSize: '1.05rem', fontWeight: 600,
                  color: '#060D14', margin: 0 }}>
                  {store.name}
                </p>
              </div>

              <span style={{ ...bs, fontSize: '11px', color: '#aaa' }}>
                {store.address || '—'}
              </span>

              {/* Badge pública / botón activar */}
              {store.is_public ? (
                <span style={{ ...bs, fontSize: '10px', fontWeight: 600,
                  letterSpacing: '0.12em', textTransform: 'uppercase',
                  color: '#16a34a', background: '#dcfce7',
                  padding: '4px 10px', borderRadius: '20px',
                  display: 'inline-block' }}>
                  ✓ Pública
                </span>
              ) : (
                <button onClick={() => handleSetPublic(store)} style={{
                  ...bs, background: 'none', border: '1px solid #e5e0e0',
                  color: '#aaa', padding: '4px 10px', cursor: 'pointer',
                  fontSize: '10px', fontWeight: 600, letterSpacing: '0.1em',
                  textTransform: 'uppercase', borderRadius: '20px',
                  transition: 'all 0.2s', display: 'inline-block',
                }}
                onMouseOver={e => { e.currentTarget.style.borderColor = '#16a34a'; e.currentTarget.style.color = '#16a34a'; }}
                onMouseOut={e => { e.currentTarget.style.borderColor = '#e5e0e0'; e.currentTarget.style.color = '#aaa'; }}>
                  Activar
                </button>
              )}

              <div style={{ display: 'flex', gap: '6px' }}>
                <button onClick={() => setEditingStore({ ...store })} style={{
                  ...bs, background: 'none', border: '1px solid #e5e0e0',
                  color: '#666', padding: '6px 12px', cursor: 'pointer',
                  fontSize: '10px', fontWeight: 600, letterSpacing: '0.1em',
                  textTransform: 'uppercase', borderRadius: '2px', transition: 'all 0.2s',
                }}
                onMouseOver={e => { e.currentTarget.style.borderColor = '#961914'; e.currentTarget.style.color = '#961914'; }}
                onMouseOut={e => { e.currentTarget.style.borderColor = '#e5e0e0'; e.currentTarget.style.color = '#666'; }}>
                  Editar
                </button>
                <button onClick={() => handleDelete(store.id)} style={{
                  ...bs, background: 'none', border: '1px solid #fee2e2',
                  color: '#dc2626', padding: '6px 8px', cursor: 'pointer',
                  fontSize: '10px', borderRadius: '2px', transition: 'all 0.2s',
                }}
                onMouseOver={e => e.currentTarget.style.background = '#fef2f2'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}>
                  <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Info tienda pública */}
      {publicStore && (
        <div style={{ marginTop: '16px', padding: '14px 20px',
          background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '2px' }}>
          <p style={{ ...bs, fontSize: '12px', color: '#16a34a', margin: 0 }}>
            <strong>"{publicStore.name}"</strong> es la tienda pública actual — 
            visible para todos los visitantes del sitio.
          </p>
        </div>
      )}
    </div>
  );
};

export default StoresPage;
